import { CircleHelp } from 'lucide-react';

export const openHelp = (key) => window.dispatchEvent(new CustomEvent('giss-help', { detail: key }));

export const HelpBtn = ({ k, testid, title }) => (
  <button type="button" className="help-q" data-testid={testid} title={title} aria-label={title} onClick={(e) => { e.stopPropagation(); openHelp(k); }}>
    <CircleHelp size={15} />
  </button>
);
